import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./SubscriptionPage.module.css";
import { PLANS, startSubscriptionApi } from "../http/http";

const SubscriptionPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [msisdn, setMsisdn] = useState("");
  const [packType, setPackType] = useState("DAILY");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(location.state?.message || "");
  const [error, setError] = useState(location.state?.error || "");

  const resetMessages = () => {
    setMessage("");
    setError("");
  };

  const handleSubscribe = async (event) => {
    event.preventDefault();
    resetMessages();
    setLoading(true);

    try {
      const result = await startSubscriptionApi({ msisdn, packType });
      const subscription = result?.data || {};
      sessionStorage.setItem(
        "subscriptionFlow",
        JSON.stringify({
          msisdn: subscription.msisdn || msisdn,
          packType: subscription.packType || packType,
          trxId: subscription.trxId,
          startedAt: Date.now(),
        })
      );
      if (!subscription.redirectUrl) {
        throw new Error("Subscription redirect URL was not returned.");
      }
      window.open(subscription.redirectUrl, "_blank", "noopener,noreferrer");
      navigate("/subscribe/waiting", { replace: true });
    } catch (err) {
      setError(err.message || "Unable to start subscription");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className={classes.main}>
      <div className={classes.card}>
        <button
          type="button"
          className={classes.backBtn}
          onClick={() => navigate("/")}
        >
          Back to Home
        </button>

        <h1 className={classes.title}>Subscribe to Kids Plex</h1>
        <p className={classes.subtitle}>
          Enter your mobile number and choose a subscription plan.
        </p>

        <form className={classes.form} onSubmit={handleSubscribe}>
          <label className={classes.label} htmlFor="msisdn">
            MSISDN
          </label>
          <input
            id="msisdn"
            type="tel"
            className={classes.input}
            placeholder="08167453846"
            value={msisdn}
            onChange={(event) => setMsisdn(event.target.value)}
            required
          />

          <p className={classes.sectionTitle}>Select Plan</p>
          <div className={classes.plans}>
            {PLANS.map((plan) => (
              <label
                key={plan.id}
                className={`${classes.planOption} ${
                  packType === plan.id ? classes.planSelected : ""
                }`}
              >
                <input
                  type="radio"
                  name="packType"
                  value={plan.id}
                  checked={packType === plan.id}
                  onChange={() => setPackType(plan.id)}
                />
                <span className={classes.planLabel}>{plan.label}</span>
                <span className={classes.planPrice}>₦{plan.amount}</span>
                <span className={classes.planMeta}>
                  serviceId {plan.serviceId}
                </span>
              </label>
            ))}
          </div>

          <button
            type="submit"
            className={classes.primaryBtn}
            disabled={loading || !msisdn}
          >
            {loading ? "Opening..." : "Subscribe Now"}
          </button>
        </form>

        {message && <p className={classes.success}>{message}</p>}
        {error && <p className={classes.error}>{error}</p>}

        <div className={classes.footerLinks}>
          <button
            type="button"
            className={classes.linkBtn}
            onClick={() => navigate("/login")}
          >
            Already subscribed? Login
          </button>
        </div>
      </div>
    </main>
  );
};

export default SubscriptionPage;
